module.exports = __webpack_public_path__ + "images/home.5fe760a75f67fc088c486240af206bd1.svg";